<template>

  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Settings</li>
      </ol>
    </div>
    <div class="main-box two-column">
      <!--      sidebar setting start-->
      <sidebar></sidebar>
      <!--      sidebar setting end-->
      <div class="setting-info-wrp">
        <!-- location -->
        <div class="box">
          <div class="sett-head">
            <h1>Leaves Setting</h1>
          </div>
          <ul class="settings">
            <li>
              <strong class="sett-title">Weekend Days</strong>
              <p>
                Monday <input type="checkbox" @change="storeWeekendDaysFun" :true-value="1" :false-value="0"
                              v-model="formData.is_monday" class="mr-15">
                Tuesday <input type="checkbox" @change="storeWeekendDaysFun" :true-value="1" :false-value="0"
                               v-model="formData.is_tuesday" class="mr-15">
                Wednesday <input type="checkbox" @change="storeWeekendDaysFun" :true-value="1" :false-value="0"
                                 v-model="formData.is_wednesday" class="mr-15">
                Thursday <input type="checkbox" @change="storeWeekendDaysFun" :true-value="1" :false-value="0"
                                v-model="formData.is_thursday" class="mr-15">
                Friday <input type="checkbox" @change="storeWeekendDaysFun" :true-value="1" :false-value="0"
                              v-model="formData.is_friday" class="mr-15">
                Saturday <input type="checkbox" @change="storeWeekendDaysFun" :true-value="1" :false-value="0"
                                v-model="formData.is_saturday" class="mr-15">
                Sunday <input type="checkbox" @change="storeWeekendDaysFun" :true-value="1" :false-value="0"
                              v-model="formData.is_sunday" class="mr-15">
              </p>
            </li>
            <li>
              <strong class="sett-title">Employees can apply leave if they are in schedule</strong>
              <p>
                <input type="checkbox" @change="updateCompanyLeaveSetting" :true-value="1" :false-value="0"
                       v-model="is_emp_can_apply_leave_if_schedule">
              </p>
            </li>
            <!--            <li>
                          <strong class="sett-title">Yearly Holidays</strong>
                          <p>
                            <input type="number"  v-model="yearly_holidays"
                                   oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                   maxlength = "4"
                            > <button @click="updateCompanyLeaveSetting" class="cursor-pointer">Save</button>
                          </p>
                        </li>-->

            <li>
              <strong class="sett-title">Leave Types</strong>
              <ul class="settings">
                <li v-if="companyLeaveTypes" v-for="leaveType in companyLeaveTypes" class="text-capitalize">
                <span>
                  {{ leaveType.name }} <i class="ico-pencil" @click="editLeaveType(leaveType)" style="cursor: pointer"></i>
                </span>
                </li>
                <li>
                  <div class="row">
                    <div class="col-6">
                      <input type="text" class="form-control" v-model="leaveTypeName" placeholder="Leave Type">
                    </div>
                    <div class="col-2">
                      <button class="btn btn-outline-primary" v-if="isLeaveTypePost==true"
                              @click="submitCompanyLeaveType">Add New
                      </button>
                      <button class="btn btn-outline-primary" v-if="isLeaveTypeUpdate==true"
                              @click="updateCompanyLeaveType">Update
                      </button>
                    </div>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>

</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import router from '../../../router/router'
import axios from "axios";
import sidebar from "./sidebar";

export default {
  components: {
    sidebar
  },
  props: [],
  data() {
    return {
      isLeaveTypePost: true,
      isLeaveTypeUpdate: false,
      is_emp_can_apply_leave_if_schedule: '',
      yearly_holidays: '',
      formData: {
        is_monday: '0',
        is_tuesday: '0',
        is_wednesday: '0',
        is_thursday: '0',
        is_friday: '0',
        is_saturday: '0',
        is_sunday: '0',
        company_id: this.$store.getters.getSelectedCompany.id,
      },
      company_id: this.$store.getters.getSelectedCompany.id,
      companyLeaveTypes: [],
      leaveTypeName: '',
      leaveId: '',

    }
  },

  created() {
    this.getCompany();
    this.getCompanyLeaveTypes();
  },
  mounted() {
  },
  methods: {
    storeWeekendDaysFun() {
      axios.post(this.$CompanyWeekendDays,
        this.formData, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.data.status === 200) {
            $root.$toast.success(res.data.message);
          }
        });
    },
    updateCompanyLeaveSetting() {
      axios.post(this.$UpdateCompanyLeaveSetting,
        {
          yearly_holidays: this.yearly_holidays,
          is_emp_can_apply_leave_if_schedule: this.is_emp_can_apply_leave_if_schedule,
          company_id: this.company_id,
        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.data.status == 200) {
            $root.$toast.success("Updated successfully");
          }
        });
    },
    getCompany() {
      axios.get(this.$showcompanies + '/' + this.company_id + '/edit', {
        headers: this.getAuthHeader(),
        params: {
          company_id: this.company_id,
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.company = res.data.result.company;
            this.is_emp_can_apply_leave_if_schedule = this.company.is_emp_can_apply_leave_if_schedule;
            this.yearly_holidays = this.company.yearly_holidays;
            this.formData = (this.company.weekendDays) ? this.company.weekendDays : '';

          }
        });
    },
    getCompanyLeaveTypes() {
      axios.get(this.$CompanyLeaveTypes, {
        headers: this.getAuthHeader(),
        params: {
          company_id: this.company_id,
        }
      })
        .then(res => {
          if (res.data.status === 200) {
            this.companyLeaveTypes = res.data.result;
          }
        });
    },
    submitCompanyLeaveType() {
      axios.post(this.$CompanyLeaveTypes,
        {
          name: this.leaveTypeName,
          company_id: this.company_id,
        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.data.status === 200) {
            $root.$toast.success("created successfully");
            this.leaveTypeName = '';
            this.getCompanyLeaveTypes();
          }
        });
    },
    editLeaveType(index) {
      this.isLeaveTypePost=false;
      this.isLeaveTypeUpdate=true;
      this.leaveId = index.id;
      this.leaveTypeName = index.name;
    },
    updateCompanyLeaveType() {
      axios.put(this.$CompanyLeaveTypes + '/' + this.leaveId,
        {
          name: this.leaveTypeName,
          company_id: this.company_id,
        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.data.status === 200) {
            $root.$toast.success("updated successfully");
            this.leaveTypeName = '';
            this.getCompanyLeaveTypes();
          }
        });
    },
    cancelCompanyLocation() {
      this.form = {};
    }
  }
}
</script>
